<template>
  <div class="qr-img bg-white" >
    <img
      class="img"
      style="display: block"
      :src="sharePictureUrl"
    />
    <transition name="van-fade">
      <div class="text-center save-tips" v-if="sharePictureUrl&&showTips">长按保存图片至相册~</div>
    </transition>
  </div>
</template>

<script>
import { apiGet } from '@/services'
import bg from '@/assets/images/bg.png'
// import center from '@/assets/images/center.png'
import canvasUtils from '@/utils/canvas'
import { Toast } from 'vant'
const setOptions = ({avatar, nickName, qrCode}) => ({
  width: 750,
  height: 1448,
  quality: 1,
  config: [
    {
      type: 'img',
      src: bg,
      x: 0,
      y: 0,
      width: 750,
      height: 1448,
      borderRadius: 0
    },
    {
      type: 'img',
      src: avatar,
      x: 148 * 2,
      y: 145,
      width: 80 * 2,
      height: 80 * 2,
      borderRadius: 40 * 2
    },
    {
      type: 'text',
      text: nickName,
      x: 375,
      y: 240 + 120,
      fontSize: 36,
      color: '#302b3e',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    {
      type: 'img',
      src: qrCode,
      x: 113 * 2 - 20,
      y: 145 + 80 * 2 + 162,
      width: 340,
      height: 340,
      borderRadius: 0
    }
  ]
})
export default {
  name: 'savePic',
  data() {
    return {
      showTips: true,
      sharePictureUrl: ''
    }
  },
  created() {
    this.generatePic()
  },
  methods: {
    generatePic() {
      Toast.loading({
      message: '图片生成中...',
      forbidClick: true,
      loadingType: 'spinner'
    })
      apiGet('partner/open/findPartnerInfo').then(res => {
      canvasUtils.drawFromConfig(setOptions({
        avatar: res.data.headImgUrl,
        qrCode: 'data:image/png;base64,' + res.data.inviteLinkQrCode,
        nickName: res.data.partnerName
      })).then((data) => {
        this.sharePictureUrl = data
        setTimeout(() => {
          this.showTips = false
        }, 3000)
      }).finally(() => {
        Toast.clear()
      })
    })
  }
}
}
</script>
<style scoped>
.bg-white{
  background: #fff;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
}
.text-center{
  text-align: center;
}
.img{
  width: 100%;
  background-color: #fff;
}
.save-tips{
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 30px;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.6);
  font-size: 10px;
  height: 24px;
  color: #fff;
}
</style>
